import { __assign } from "tslib";
import { namespacedClassnames } from '../../common';
import * as React from 'react';
import { Popover, ArrowContainer } from 'react-tiny-popover';
import { Tooltip } from '..';
import { TOOLTIP_CLOSE_TRANSITION_DELAY } from '../../common/popper-engine';
import { LibColor } from '../../new-libby';
var popoverPlacesMap = {
    right: 'right',
    left: 'left',
    below: 'bottom',
    above: 'top'
};
export var PopoverOuterActionOrigin;
(function (PopoverOuterActionOrigin) {
    PopoverOuterActionOrigin[PopoverOuterActionOrigin["escape"] = 0] = "escape";
    PopoverOuterActionOrigin[PopoverOuterActionOrigin["scroll"] = 1] = "scroll";
    PopoverOuterActionOrigin[PopoverOuterActionOrigin["click"] = 2] = "click";
})(PopoverOuterActionOrigin || (PopoverOuterActionOrigin = {}));
export var BasePopover = function (props) {
    var _a = React.useState(!!props.isOpen), isPopoverOpen = _a[0], setIsPopoverOpen = _a[1];
    var _b = React.useState(false), isTooltipForceHidden = _b[0], setIsTooltipForceHidden = _b[1];
    var buttonRef = React.useRef(null);
    var isUncontrolled = props.isOpen === undefined;
    var lastScrollTop = null;
    var getPopoverPlace = function (place) {
        return popoverPlacesMap[place] || 'bottom';
    };
    var adjustedPreferPlace = getPopoverPlace(props.preferPlace || 'below');
    var handleKeyUp = function (e) {
        if ((props.isOpen || isPopoverOpen) && e.key === 'Escape') {
            props.onOuterAction && props.onOuterAction(undefined, PopoverOuterActionOrigin.escape);
            if (isUncontrolled) {
                closePopover();
            }
        }
    };
    var handleScroll = function (event) {
        if (event.target) {
            if ((props.isOpen || isPopoverOpen) && lastScrollTop) {
                if (Math.abs(lastScrollTop - event.target.scrollTop) > 20) {
                    props.onOuterAction && props.onOuterAction(undefined, PopoverOuterActionOrigin.scroll);
                    if (isUncontrolled) {
                        closePopover();
                    }
                }
            }
            else {
                lastScrollTop = event.target.scrollTop;
            }
        }
    };
    React.useEffect(function () {
        if (props.triggerOuterOnEsc) {
            window.addEventListener('keyup', handleKeyUp);
            return function () {
                window.removeEventListener('keyup', handleKeyUp);
            };
        }
        return function () { };
    }, [props.onOuterAction, props.isOpen, isPopoverOpen]);
    React.useEffect(function () {
        if (props.triggerOuterOnScroll) {
            window.addEventListener('scroll', handleScroll, true);
            return function () {
                window.removeEventListener('scroll', handleScroll, true);
            };
        }
        return function () { };
    }, [props.onOuterAction, props.isOpen, isPopoverOpen]);
    var onClickOuterAction = function (e) {
        props.onOuterAction && props.onOuterAction(e, PopoverOuterActionOrigin.click);
        if (isUncontrolled) {
            closePopover();
        }
    };
    var openPopover = function () {
        if (isUncontrolled && !!props.tooltipText) {
            setIsTooltipForceHidden(true);
            setTimeout(function () {
                setIsPopoverOpen(true);
            }, TOOLTIP_CLOSE_TRANSITION_DELAY);
        }
        else {
            setIsPopoverOpen(true);
            setIsTooltipForceHidden(false);
        }
    };
    var closePopover = function () {
        setIsPopoverOpen(false);
        setIsTooltipForceHidden(false);
    };
    var classNames = React.useMemo(function () { return namespacedClassnames('Popover', props.popoverType) + (props.className ? " ".concat(props.className) : ''); }, [props.className, props.popoverType]);
    var childrenBody = props.children;
    var popoverProps = __assign(__assign({}, props), { preferPlace: adjustedPreferPlace, enterExitTransitionDurationMs: 250 });
    var renderChildren = isUncontrolled && !!props.tooltipText ? (React.createElement(Tooltip, { forceHidden: isTooltipForceHidden, body: props.tooltipText }, childrenBody)) : childrenBody;
    var renderClickableChildren = (React.createElement("div", { className: namespacedClassnames('popover-clickable-body-container'), onClick: openPopover, ref: buttonRef }, renderChildren));
    var contentWithArrow = function (_a) {
        var childRect = _a.childRect, popoverRect = _a.popoverRect, position = _a.position;
        return (React.createElement(ArrowContainer, { position: position, childRect: childRect, popoverRect: popoverRect, arrowColor: LibColor.white, arrowSize: 7 },
            React.createElement("div", { className: 'Popover-body' }, props.body)));
    };
    return (React.createElement("div", null,
        React.createElement(Popover, __assign({}, popoverProps, { isOpen: isUncontrolled ? isPopoverOpen : props.isOpen, containerClassName: classNames, positions: adjustedPreferPlace, onClickOutside: onClickOuterAction, clickOutsideCapture: true, reposition: true, content: contentWithArrow, align: 'center', transformMode: 'relative' }),
            React.createElement("div", null, isUncontrolled ? renderClickableChildren : renderChildren))));
};
//# sourceMappingURL=base-popover.js.map